import { useTranslation } from "react-i18next";
import PanelsLayout from "components/PanelsLayout";
import { useContext, useState } from "react";
import styles from "./styles.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import EmptyPanel from "components/EmptyPanel";
import { useDebounce } from "use-debounce";
import { ChatList } from "./chatList";
import ChatView from "components/ChatView";
import ChatAddIcon from "assets/icons/chati.svg?react";
import { Tooltip } from "@mui/material";
import ModalsManagerContext from "contexts/ModalsManager";

const ChatModule = () => {
  const { t } = useTranslation();
  const { modals, setModals } = useContext(ModalsManagerContext);
  const { chatId } = useParams();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  const [debouncedText] = useDebounce(searchText, 300);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  const leftPanel = () => {
    // if (view === "edelivery") {
    //   return (
    //     <MessagesRegister
    //       kind={ItemKind.EDeliveryMessage}
    //       searchText={debouncedText}
    //     ></MessagesRegister>
    //   );
    // }

    return (
      <ChatList
        searchText={searchText}
        debouncedText={debouncedText}
      ></ChatList>
    );
  };

  const getLeftPanelTitle = () => {
    return t("navigation.chat");
  };

  const getLeftPanelSubtitle = () => {
    return t("chat.title");
  };

  const handleNewChat = () => {
    setModals({ ...modals, createChat: true });
  };

  const rightPanel = () => {
    if (chatId) {
      return <ChatView chatId={chatId}></ChatView>;
    }
    return <EmptyPanel />;

    // return (
    //   <>
    //     <UserRightSide userId={userId} />
    //     {/* <ClientNew clientId={clientId} /> */}
    //   </>
    // );
  };

  return (
    <PanelsLayout
      title={getLeftPanelTitle()}
      subTitle={getLeftPanelSubtitle()}
      onChangeSearch={handleChangeSearchBar}
      leftPanel={leftPanel()}
      leftClassName={styles.leftPanel}
      rightPanel={rightPanel()}
      headerRight={
        <div className={styles.icon} onClick={handleNewChat}>
          <Tooltip title={t("chat.newChat")}>
            <div>
              <ChatAddIcon></ChatAddIcon>
            </div>
          </Tooltip>
        </div>
      }
    />
  );
};
export default ChatModule;
